import { Modal, ModalBody, ModalButton, ModalFooter, ModalHeader } from 'baseui/modal'
import OptInSmsTextField from '@/shared/components/HOPComponents/OptInSmsTextField/OptInSmsTextField'
import useOptInSmsModal from './useOptInSmsModal'

const OptInSmsModal = () => {
  const { t, isOpen, draft, saving, onClose, onDraftChange, onSave } = useOptInSmsModal()

  return (
    <Modal isOpen={isOpen} onClose={onClose}>
      <ModalHeader>{t('organizationManagement:opt_in_sms_modal_title')}</ModalHeader>
      <ModalBody>
        <OptInSmsTextField value={draft} onChange={onDraftChange} />
      </ModalBody>
      <ModalFooter>
        <ModalButton kind='tertiary' onClick={onClose}>
          {t('common:cancel')}
        </ModalButton>
        <ModalButton kind='primary' isLoading={saving} onClick={onSave}>
          {t('common:save')}
        </ModalButton>
      </ModalFooter>
    </Modal>
  )
}

export default OptInSmsModal
